var _path, _g, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgFacialFullness = function SvgFacialFullness(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20",
    stroke: "currentColor",
    role: "img",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "facial_fullness_svg__a",
    width: 16,
    height: 18,
    x: 2,
    y: 1,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M2.5 1.667h15v16.667h-15z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    mask: "url(#facial_fullness_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.833 2.5c0 8.284-4.29 15-9.583 15s-9.583-6.716-9.583-15"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeWidth: 0.7,
    d: "M11.667 10.4c.352-.132 1.722-.946 2.115-1.504.529-.75 1.939-.75 2.468 0 .529-.747 1.939-.747 2.644 0 .824.872 1.587 1.372 1.94 1.504m-9.167 0c.587.7 2.644 2.1 4.583 2.1 2.291 0 3.937-1.4 4.583-2.1m-9.166 0h9.166"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m2.5 14.167.033-.033A12.8 12.8 0 0 0 5 10.834a14.5 14.5 0 0 0 2.5 3.333 8.36 8.36 0 0 0-2.31 2.93L5 17.5l-.16-.356a7.9 7.9 0 0 0-2.34-2.977M4.986 7.904 5 7.917a5.4 5.4 0 0 0-1.555 1.862L3.333 10l-.09-.19a5.1 5.1 0 0 0-1.576-1.893l.042-.038a8 8 0 0 0 1.624-2.046 9 9 0 0 0 1.653 2.07"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFacialFullness);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;